// A0 - Ünite 3: BE Fiili (am/is/are) & Kimlik/Meslek
// Hedef: BE fiilinin tüm formları, olumlu, olumsuz, soru

export const A0_UNIT_3 = {
  'A0-U3-L1': {
    id: 'A0-U3-L1',
    title: 'BE Fiili: I am, You are, He/She/It is',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 BE Fiili Nedir?',
          explanation: 'BE fiili İngilizcenin en temel fiilidir. "olmak" anlamına gelir ve kişiye göre değişir: am, is, are.',
          formula: 'Subject + BE (am/is/are) + Complement'
        },
        {
          type: 'grammar',
          title: '📊 BE Fiili Tablosu',
          table: {
            headers: ['Kişi', 'BE Fiili', 'Örnek', 'Türkçe'],
            rows: [
              ['I (Ben)', 'am', 'I am a pilot.', 'Ben bir pilotum.'],
              ['You (Sen/Siz)', 'are', 'You are a passenger.', 'Sen bir yolcusun.'],
              ['He (O-erkek)', 'is', 'He is the captain.', 'O kaptan.'],
              ['She (O-kadın)', 'is', 'She is a flight attendant.', 'O bir kabin memuru.'],
              ['It (O-nesne)', 'is', 'It is a Boeing 737.', 'O bir Boeing 737.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✍️ Kısaltmalar (Contractions)',
          table: {
            headers: ['Uzun Form', 'Kısa Form', 'Örnek'],
            rows: [
              ['I am', "I'm", "I'm ready."],
              ['You are', "You're", "You're welcome."],
              ['He is', "He's", "He's the pilot."],
              ['She is', "She's", "She's friendly."],
              ['It is', "It's", "It's on time."]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Kısaltmalar günlük konuşmada çok kullanılır. Yazılı resmi metinlerde uzun form tercih edilir.'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Meslekleri',
          words: [
            { en: 'pilot', tr: 'pilot', example: 'He is a pilot.' },
            { en: 'captain', tr: 'kaptan', example: 'She is the captain.' },
            { en: 'co-pilot / first officer', tr: 'yardımcı pilot', example: 'He is the co-pilot.' },
            { en: 'flight attendant', tr: 'kabin memuru', example: 'I am a flight attendant.' },
            { en: 'cabin crew', tr: 'kabin ekibi', example: 'We are cabin crew.' },
            { en: 'purser', tr: 'kabin amiri', example: 'She is the purser.' },
            { en: 'ground staff', tr: 'yer hizmetleri', example: 'They are ground staff.' },
            { en: 'passenger', tr: 'yolcu', example: 'You are a passenger.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'Doğru BE fiilini yazın (am/is/are)',
          sentences: [
            { text: 'I ___ a cabin crew member.', answer: 'am' },
            { text: 'She ___ the purser.', answer: 'is' },
            { text: 'You ___ welcome on board.', answer: 'are' },
            { text: 'He ___ a pilot.', answer: 'is' },
            { text: 'It ___ a long flight.', answer: 'is' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"I ___ ready for the flight." Boşluğa ne gelir?',
          options: ['is', 'are', 'am', 'be'],
          correctIndex: 2,
          explanation: '"I" zamiri ile "am" kullanılır.'
        },
        {
          type: 'matching',
          instruction: 'Zamirleri BE fiilleriyle eşleştirin',
          pairs: [
            { left: 'I', right: 'am' },
            { left: 'You', right: 'are' },
            { left: 'He', right: 'is' },
            { left: 'She', right: 'is' },
            { left: 'It', right: 'is' }
          ]
        }
      ]
    }
  },

  'A0-U3-L2': {
    id: 'A0-U3-L2',
    title: 'BE Fiili: We are, They are',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Çoğul Özneler',
          table: {
            headers: ['Kişi', 'BE Fiili', 'Örnek', 'Türkçe'],
            rows: [
              ['We (Biz)', 'are', 'We are the cabin crew.', 'Biz kabin ekibiyiz.'],
              ['They (Onlar)', 'are', 'They are passengers.', 'Onlar yolcular.'],
              ['You (Siz-çoğul)', 'are', 'You are all welcome.', 'Hepiniz hoş geldiniz.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✍️ Kısaltmalar',
          table: {
            headers: ['Uzun Form', 'Kısa Form', 'Örnek'],
            rows: [
              ['We are', "We're", "We're ready for takeoff."],
              ['They are', "They're", "They're boarding now."],
              ['You are', "You're", "You're in business class."]
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Tüm BE Fiili Tablosu',
          table: {
            headers: ['Tekil', 'BE', 'Çoğul', 'BE'],
            rows: [
              ['I', 'am', 'We', 'are'],
              ['You', 'are', 'You', 'are'],
              ['He/She/It', 'is', 'They', 'are']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 KURAL: "are" hem tekil "you" hem çoğul "you, we, they" için kullanılır.'
        },
        {
          type: 'example',
          title: '✈️ Kabin Senaryoları',
          items: [
            { en: 'We are your cabin crew today.', tr: 'Bugün kabin ekibiniz biziz.' },
            { en: 'They are seated in row 15.', tr: 'Onlar 15. sırada oturuyorlar.' },
            { en: 'We are ready for departure.', tr: 'Kalkışa hazırız.' },
            { en: 'They are VIP passengers.', tr: 'Onlar VIP yolcular.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          sentences: [
            { text: 'We ___ the flight crew.', answer: 'are' },
            { text: 'They ___ from Istanbul.', answer: 'are' },
            { text: 'You ___ all in economy class.', answer: 'are' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"The passengers ___ on board." Boşluğa ne gelir?',
          options: ['am', 'is', 'are', 'be'],
          correctIndex: 2,
          explanation: '"The passengers" = "They" = are'
        },
        {
          type: 'rewrite',
          instruction: 'Kısaltarak yazın',
          sentences: [
            { original: 'We are ready.', answer: "We're ready." },
            { original: 'They are late.', answer: "They're late." }
          ]
        }
      ]
    }
  },

  'A0-U3-L3': {
    id: 'A0-U3-L3',
    title: 'BE Fiili: Olumsuz (Negative)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Olumsuz Yapı',
          explanation: 'BE fiilinin olumsuzunu yapmak için "not" eklenir.',
          formula: 'Subject + BE + NOT + Complement'
        },
        {
          type: 'grammar',
          title: '📊 Olumsuz Tablo',
          table: {
            headers: ['Olumlu', 'Olumsuz (Uzun)', 'Olumsuz (Kısa)', 'Türkçe'],
            rows: [
              ['I am', 'I am not', "I'm not", 'Ben değilim'],
              ['You are', 'You are not', "You aren't / You're not", 'Sen değilsin'],
              ['He is', 'He is not', "He isn't / He's not", 'O değil'],
              ['She is', 'She is not', "She isn't / She's not", 'O değil'],
              ['It is', 'It is not', "It isn't / It's not", 'O değil'],
              ['We are', 'We are not', "We aren't / We're not", 'Biz değiliz'],
              ['They are', 'They are not', "They aren't / They're not", 'Onlar değil']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 DİKKAT: "I am not" sadece "I\'m not" olarak kısaltılır. "I amn\'t" YANLIŞTIR!'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'The flight is not delayed.', tr: 'Uçuş gecikmedi.' },
            { en: 'I am not the captain.', tr: 'Ben kaptan değilim.' },
            { en: 'They are not in business class.', tr: 'Onlar business class\'ta değil.' },
            { en: 'It isn\'t a direct flight.', tr: 'Direkt uçuş değil.' },
            { en: 'We aren\'t ready yet.', tr: 'Henüz hazır değiliz.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'transform',
          instruction: 'Olumsuza çevirin (kısa form)',
          sentences: [
            { original: 'He is a pilot.', answer: "He isn't a pilot." },
            { original: 'They are ready.', answer: "They aren't ready." },
            { original: 'I am late.', answer: "I'm not late." },
            { original: 'The flight is on time.', answer: "The flight isn't on time." }
          ]
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi YANLIŞTIR?',
          options: ["I'm not ready", "He isn't here", "I amn't a pilot", "They aren't late"],
          correctIndex: 2,
          explanation: '"I amn\'t" diye bir kısaltma YOKTUR. Doğrusu: "I\'m not"'
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'The seat ___ available. (is not - kısa)', answer: "isn't" },
            { text: 'We ___ in first class. (are not - kısa)', answer: "aren't" },
            { text: 'I ___ the purser. (am not - kısa)', answer: "'m not" }
          ]
        }
      ]
    }
  },

  'A0-U3-L4': {
    id: 'A0-U3-L4',
    title: 'BE Fiili: Soru (Question)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Soru Yapma',
          explanation: 'BE fiili ile soru yapmak için BE fiili başa alınır.',
          formula: 'BE + Subject + Complement + ?'
        },
        {
          type: 'grammar',
          title: '📊 Soru Tablosu',
          table: {
            headers: ['Olumlu', 'Soru', 'Kısa Cevap (+)', 'Kısa Cevap (-)'],
            rows: [
              ['I am ready.', 'Am I ready?', 'Yes, you are.', 'No, you aren\'t.'],
              ['You are a pilot.', 'Are you a pilot?', 'Yes, I am.', 'No, I\'m not.'],
              ['He is the captain.', 'Is he the captain?', 'Yes, he is.', 'No, he isn\'t.'],
              ['She is Turkish.', 'Is she Turkish?', 'Yes, she is.', 'No, she isn\'t.'],
              ['It is delayed.', 'Is it delayed?', 'Yes, it is.', 'No, it isn\'t.'],
              ['We are late.', 'Are we late?', 'Yes, we are.', 'No, we aren\'t.'],
              ['They are here.', 'Are they here?', 'Yes, they are.', 'No, they aren\'t.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Kısa cevapta "Yes, I\'m." YANLIŞTIR! Doğrusu: "Yes, I am." (Kısaltma yapılmaz)'
        },
        {
          type: 'example',
          title: '✈️ Kabin Soruları',
          items: [
            { en: 'Are you comfortable?', tr: 'Rahat mısınız?' },
            { en: 'Is this your seat?', tr: 'Bu sizin koltuğunuz mu?' },
            { en: 'Is the flight on time?', tr: 'Uçuş saatinde mi?' },
            { en: 'Are we ready for takeoff?', tr: 'Kalkışa hazır mıyız?' },
            { en: 'Is there a problem?', tr: 'Bir sorun mu var?' }
          ]
        }
      ],
      exercises: [
        {
          type: 'transform',
          instruction: 'Soruya çevirin',
          sentences: [
            { original: 'He is a passenger.', answer: 'Is he a passenger?' },
            { original: 'They are ready.', answer: 'Are they ready?' },
            { original: 'You are the captain.', answer: 'Are you the captain?' },
            { original: 'It is a direct flight.', answer: 'Is it a direct flight?' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"___ you a cabin crew member?" Boşluğa ne gelir?',
          options: ['Is', 'Am', 'Are', 'Be'],
          correctIndex: 2
        },
        {
          type: 'shortAnswer',
          instruction: 'Kısa cevap verin',
          questions: [
            { question: 'Are you ready? (Evet)', answer: 'Yes, I am.' },
            { question: 'Is he the pilot? (Hayır)', answer: 'No, he isn\'t.' },
            { question: 'Are they passengers? (Evet)', answer: 'Yes, they are.' }
          ]
        }
      ]
    }
  },

  'A0-U3-L5': {
    id: 'A0-U3-L5',
    title: 'Uygulama: Kendini Tanıtma',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'scenario',
          title: '✈️ Senaryo: İlk Gün',
          context: 'İlk uçuşunuzda kendinizi tanıtıyorsunuz.',
          dialogues: [
            {
              speaker: 'Kıdemli Kabin Memuru',
              text: 'Hello! Are you the new cabin crew member?',
              translation: 'Merhaba! Yeni kabin memuru siz misiniz?'
            },
            {
              speaker: 'Siz',
              text: 'Yes, I am. I am Ayşe. I am from Istanbul.',
              translation: 'Evet, benim. Ben Ayşe. İstanbul\'danlıyım.'
            },
            {
              speaker: 'Kıdemli Kabin Memuru',
              text: 'Nice to meet you, Ayşe. I am Mehmet. I am the purser on this flight.',
              translation: 'Tanıştığımıza memnun oldum, Ayşe. Ben Mehmet. Bu uçuşta kabin amiriyim.'
            },
            {
              speaker: 'Siz',
              text: 'Nice to meet you too. Is this flight full?',
              translation: 'Ben de memnun oldum. Bu uçuş dolu mu?'
            },
            {
              speaker: 'Kıdemli Kabin Memuru',
              text: 'Yes, it is. We have 180 passengers today.',
              translation: 'Evet, dolu. Bugün 180 yolcumuz var.'
            }
          ]
        },
        {
          type: 'interview',
          title: '🎭 Mülakat Hazırlığı',
          question: 'Tell me about yourself. (Bize kendinizden bahsedin.)',
          sampleAnswer: 'Hello. I am [Adınız]. I am from [S̈ehir]. I am [yaş] years old. I am a university graduate. I am interested in the aviation industry. I am hardworking and friendly.',
          tips: [
            'BE fiilini doğru kullanın: I am, NOT "I is"',
            'Kısa ve net konuşun',
            'Gülümseyin ve göz teması kurun'
          ]
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Kendinizi tanıtın. Aşağıdaki bilgileri kullanın:',
          template: 'I am ___. I am from ___. I am ___ years old. I am ___.',
          hints: ['Adınız', 'Şehriniz', 'Yaşınız', 'Mesleğiniz/Öğrenci']
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'I ___ from Turkey.', answer: 'am' },
            { text: 'She ___ a cabin crew member.', answer: 'is' },
            { text: '___ you ready for the interview?', answer: 'Are' },
            { text: 'It ___ my first flight.', answer: 'is' }
          ]
        },
        {
          type: 'errorCorrection',
          instruction: 'Hataları bulun ve düzeltin',
          sentences: [
            { wrong: 'I is a pilot.', correct: 'I am a pilot.' },
            { wrong: 'She are Turkish.', correct: 'She is Turkish.' },
            { wrong: 'They is passengers.', correct: 'They are passengers.' },
            { wrong: 'We is ready.', correct: 'We are ready.' }
          ]
        }
      ]
    }
  },

  'A0-U3-EXAM': {
    id: 'A0-U3-EXAM',
    title: '📝 Ünite 3 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 15,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: '"I ___ a cabin crew member." Boşluğa ne gelir?',
          options: ['is', 'are', 'am', 'be'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: '"They ___ passengers." Boşluğa ne gelir?',
          options: ['is', 'are', 'am', 'be'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi DOĞRU?',
          options: ['He are a pilot.', 'She is the purser.', 'They is late.', 'I are ready.'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: '"He is not" nasıl kısaltılır?',
          options: ['He\'s not / He isn\'t', 'He not is', 'He amn\'t', 'He aren\'t'],
          correctIndex: 0
        },
        {
          type: 'multipleChoice',
          question: '"You are a pilot." soruya çevirin:',
          options: ['You are a pilot?', 'Are you a pilot?', 'Is you a pilot?', 'Do you are a pilot?'],
          correctIndex: 1
        },
        {
          type: 'fillBlank',
          question: '"___ she Turkish?" (BE fiili)',
          answer: 'Is'
        },
        {
          type: 'fillBlank',
          question: '"We ___ ready." (olumsuz - are not kısa)',
          answer: "aren't"
        },
        {
          type: 'multipleChoice',
          question: '"Are you the captain?" - "Yes, ___"',
          options: ['I\'m.', 'I am.', 'I are.', 'am I.'],
          correctIndex: 1
        }
      ]
    }
  }
};

export default A0_UNIT_3;
